
<template>
  <div class="mask" v-if="isShowEvaluate">
    <div class="evaluate-box">
      <div class="header">
        <span>{{evaluateInfo.title}}</span>
        <img class="close-btn" src="../../assets/images/close.png" alt="" @click="closeEvaluate">
      </div>
      <div class="body">
        <img class="evaluate-face" :src="face.current" alt="">
        <div class="star-list" v-if="evaluateInfo.status">
          <span v-for="(item, index) in starList" :key="index" :class="['star-list-item', item.isOk && 'active']" @click="onStar(index)"></span>
        </div>
        <div class="star-list" v-else>
          <span v-for="(item, index) in starList" :key="index" :class="['star-list-item disabled', item.isOk && 'active']"></span>
        </div>
        <p class="hint">欢迎来拍砖，我们会大力改进！</p>
        <div class="tag-list">
          <span v-for="(item, index) in tagList" :key="index" :class="['tag-list-item', item.isSelected && 'active']" @click="onTag(index)">
            {{item.name}}
          </span>
        </div>
        <el-input :disabled="!evaluateInfo.status" v-model="evaluateInfo.comment" type="textarea" :rows="3" maxlength="200" placeholder="其他想说的，请您补充（1-200字）"/>
        <div class="btn">
          <el-button v-if="evaluateInfo.status" @click="submitEvalute" type="primary">提交评论</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { submitEvaluate } from '@/server/videoRoom';
export default {
  props: {
    isShowEvaluate: {
      type: Boolean,
      default: false
    },
    evaluateInfo: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      starList: [
        {
          isOk: true
        },
        {
          isOk: true
        },
        {
          isOk: true
        },
        {
          isOk: true
        },
        {
          isOk: true
        },
      ],
      face: {
        current: '//kandian-pc-1254383113.cos.ap-beijing.myqcloud.com/very-good.png',
        list: {
          noGood: '//kandian-pc-1254383113.cos.ap-beijing.myqcloud.com/no-good.png',
          good: '//kandian-pc-1254383113.cos.ap-beijing.myqcloud.com/good.png',
          veryGood: '//kandian-pc-1254383113.cos.ap-beijing.myqcloud.com/very-good.png',
        }
      },
      tagList: [],
    }
  },

  mounted() {
    const { evaluateTags, starNum } = this.evaluateInfo;
    this.tagList = evaluateTags[starNum];
    this.onStar(starNum - 1);
  },

  methods: {
    onStar(i) {
      this.starList.forEach((item, index) => {
        if(index > i) {
          item.isOk = false;
        }else {
          item.isOk = true;
        }
      });
      if(i === 0) {
        this.face.current = this.face.list.noGood;
      }else if(i > 0 && i <= 2) {
        this.face.current = this.face.list.good;
      }else {
        this.face.current = this.face.list.veryGood;
      }
      if(this.evaluateInfo.status) {
        this.evaluateInfo.starNum = i + 1;
        this.tagList = this.evaluateInfo.evaluateTags[this.evaluateInfo.starNum].map(item => {
          item.isSelected = false;
          return item;
        });
      }
    },
    onTag(i) {
      if(!this.evaluateInfo.status) {
        return;
      }
      if(this.tagList[i].isSelected) {
        this.tagList[i].isSelected = false;
      }else {
        this.tagList[i].isSelected = true;
      }
    },
    async submitEvalute() {
      const { courseId, comment, starNum } = this.evaluateInfo
      let params = {};
      params.courseId = courseId;
      params.comment = comment;
      params.star = starNum;
      params.tags = this.tagList.map(item => {
        if(item.isSelected) {
          return item.name;
        }
      })
      const { code, data, msg } = await submitEvaluate('?r=courses/evaluate', params, 'POST');
      if(code === 0) {
        this.evaluateInfo.status = false;
        this.$emit('stopTimer');
      }else {
        this.$message.error(msg)
      }
    },
    closeEvaluate() {
      this.$emit('closeEvaluate');
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/style.scss';
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.7)
}
.evaluate-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 490px;
  min-height: 484px;
  background-color: #ffffff;
  border: 1px solid #6D6D6D;
  font-size: 14px;
  color: #333333;
  border-radius: 4px;
  .header {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    @include flex-between-and-vertical-center();
    font-weight:500;
    border-bottom: 1px solid #DDDDDD;
  }
  .body {
    padding: 20px 20px 25px;
    text-align: center;
    .evaluate-face {
      width: 50px;
      height: 50px;
    }
    .star-list {
      width: 149px;
      margin: 16px auto 8px;
      @include flex-between-and-vertical-center();
      .star-list-item {
        display: inline-block;
        width: 21px;
        height: 19px;
        background: url(../../assets/images/icons/star.png) no-repeat center;
        background-size: cover;
        cursor: pointer;
        &.disabled {
          cursor: default;
        }
        &.active {
          background: url(../../assets/images/icons/star-active.png) no-repeat center;
          background-size: cover;
        }
      }
    }
    .hint {
      line-height: 20px;
      color: #666666;
      margin-bottom: 20px;
    }
  }
  .close-btn {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }
  .tag-list {
    @include flex-wrap();
    .tag-list-item {
      width: 140px;
      border: 1px solid #DDDDDD;
      border-radius: 3px;
      padding: 3.5px 10px;
      margin-right: 14px;
      margin-bottom: 15px;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &.active {
        position: relative;
        border: 1px solid #FC8D40;
        color: #FC8D40;
        &::after {
          content: '';
          display: block;
          width: 16px;
          height: 16px;
          background: url(../../assets/images/icons/icon-tag-active.png) no-repeat center;
          background-size: cover;
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
    }
  }
  .btn {
    margin-top: 20px;
  }
}
textarea {
  background: #D8D8D8;
}
</style>






// WEBPACK FOOTER //
// src/components/videoRoom/evaluate.vue